angular.module('impactx.search').controller('LotItemActionCtrl', [
    'TranslationService',
    '$redirect',
    'ThemeWorldService',
    'panelService',
    '$context',
    'RFXCreateService',
    'ProductViewService',
    LotItemActionsCtrl]);

function LotItemActionsCtrl(TranslationService, $redirect, ThemeWorldService, panelService, $context, RFXCreateService, ProductViewService) {
    var self = this;

    self.trns = {
        addToThemeWorld: TranslationService.get('addToThemeWorld'),
        removeFromThemeWorld: TranslationService.get('removeFromThemeWorld'),
        createRFX: TranslationService.get('createRFX'),
        addToProductView: TranslationService.get('addToProductView'),
        removeFromProductView: TranslationService.get('removeFromProductView')
    };

    self.$onInit = function () {
        self.hasActions = self.lot.canAddToThemeWorld || self.lot.canAddToProductView || self.lot.canRemoveFromThemeWorld || self.lot.showRFXButton || self.lot.canRemoveFromProductView;
    };

    self.addToThemeWorld = function($event) {
        self.lot.canAddToThemeWorld = false;
        self.lot.canRemoveFromThemeWorld = true;
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ThemeWorldService.addLotsToThemeWorld([self.lot]);
    };

    self.addToProductView = function($event) {
        self.lot.canAddToProductView = false;
        self.lot.canRemoveFromProductView = true;
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ProductViewService.addLotsToProductView([self.lot]);
    };

    self.removeFromThemeWorld = function($event) {
        var lotIds = [];
        self.lot.canAddToThemeWorld = true;
        self.lot.canRemoveFromThemeWorld = false;
        lotIds.push(self.lot.id);
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ThemeWorldService.removeLotsFromThemeWorld($context.hasActiveThemeWorld.id, lotIds);
    };

    self.removeFromProductView = function($event) {
        var lotIds = [];
        self.lot.canAddToProductView = true;
        self.lot.canRemoveFromProductView = false;
        lotIds.push(self.lot.id);
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ProductViewService.removeLotsFromProductView($context.hasActiveProductView.id, lotIds);
    };

    self.createRFX = function(){
        RFXCreateService.createRFX("lot", self.lot.id);
    };
}